export default __webpack_public_path__ + "static/media/What we offer - Fintech 1.857e2890.png";